<template>
  <div ref="wrapper" class="rj-wrapper">
    <div class="rj-scroll__content">
      <div style="height: 100%">
        <slot>
          <ul class="list-content">
            <li @click="clickItem($event,item)" class="list-item" v-for="(item,index) in data" :key="index">{{ item }}</li>
          </ul>
        </slot>
      </div>
      <slot name="pullup"
            :pullUpLoad="pullUpLoad"
            :isPullUpLoad="isPullUpLoad"
      >
        <div class="rj-wrapper__pullup" v-if="pullUpLoad">
          <div class="before-trigger" v-if="!isPullUpLoad">
            <span>{{ pullUpTxt }}</span>
          </div>
          <div class="after-trigger" v-else>
            <loading/>
          </div>
        </div>
      </slot>
    </div>
    <slot name="pulldown"
          :pullDownRefresh="pullDownRefresh"
          :pullDownStyle="pullDownStyle"
          :beforePullDown="beforePullDown"
          :isPullingDown="isPullingDown"
          :bubbleY="bubbleY"
    >
      <div ref="pulldown" class="rj-wrapper__pulldown" :style="pullDownStyle?pullDownStyle:'top:-180px'" v-if="pullDownRefresh">
        <div class="" v-if="beforePullDown">
          <bubble :y="bubbleY"/>
        </div>
        <div class="rj-wrapper__pulldown-after" v-else>
          <div v-if="isPullingDown" class="loading">
            <loading/>
          </div>
          <div v-else><span>{{ refreshTxt }}</span></div>
        </div>
      </div>
    </slot>
  </div>
</template>
<script type="es6">
import BScroll from '@better-scroll/core';
import Loading from './loading.vue';
import Bubble from './bubble.vue';
import { getRect } from './lib';
const DIRECTION_H = 'horizontal';
const DIRECTION_V = 'vertical';
let focusTimer;
export default {
  name: 'RjScroll',
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      }
    },
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    listenBeforeScroll: {
      type: Boolean,
      default: false
    },
    listenScrollEnd: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: DIRECTION_V
    },
    scrollbar: {
      type: null,
      default: false
    },
    pullDownRefresh: {
      type: null,
      default: false
    },
    pullUpLoad: {
      type: null,
      default: false
    },
    startY: {
      type: Number,
      default: 0
    },
    refreshDelay: {
      type: Number,
      default: 20
    },
    freeScroll: {
      type: Boolean,
      default: false
    },
    mouseWheel: {
      type: Boolean,
      default: false
    },
    bounce: {
      type: Boolean,
      default: true
    },
    zoom: {
      type: Boolean,
      default: false
    },
    listenInputKeyboard: {
      type: Boolean,
      default: false
    },
    InputKeyboardOffsetY: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      beforePullDown: true,
      isRebounding: false,
      isPullingDown: false,
      isPullUpLoad: false,
      pullUpDirty: true,
      pullDownStyle: '',
      bubbleY: 0
    };
  },
  computed: {
    pullUpTxt () {
      const moreTxt = (this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.moreTxt);
      const noMoreTxt = (this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.noMoreTxt);
      return this.pullUpDirty ? moreTxt : noMoreTxt;
    },
    refreshTxt () {
      return (this.pullDownRefresh && this.pullDownRefresh.txt);
    }
  },
  created () {
    this.pullDownInitTop = -50;
  },
  mounted () {
    setTimeout(() => {
      this.initScroll();
    }, 20);
  },
  destroyed () {
    this.$refs.scroll && this.$refs.scroll.destroy();
  },
  methods: {
    async initScroll () {
      if (!this.$refs.wrapper) {
        return;
      }
      if (this.$refs.listWrapper && (this.pullDownRefresh || this.pullUpLoad)) {
        this.$refs.listWrapper.style.minHeight = `${getRect(this.$refs.wrapper).height + 1}px`;
      }
      if (this.pullDownRefresh) {
        let pd = await require('@better-scroll/pull-down');
        BScroll.use(pd.default);
      }
      if (this.pullUpLoad) {
        let pup = await require('@better-scroll/pull-up');
        BScroll.use(pup.default);
      }
      if (this.mouseWheel) {
        let mouseWheel = await require('@better-scroll/mouse-wheel');
        BScroll.use(mouseWheel.default);
      }
      if (this.scrollbar) {
        let ScrollBar = await require('@better-scroll/scroll-bar');
        BScroll.use(ScrollBar.default);
      }
      let options = {
        probeType: this.probeType,
        click: this.click,
        scrollY: this.freeScroll || this.direction === DIRECTION_V,
        scrollX: this.freeScroll || this.direction === DIRECTION_H,
        scrollbar: this.scrollbar,
        pullDownRefresh: this.pullDownRefresh,
        pullUpLoad: this.pullUpLoad,
        startY: this.startY,
        freeScroll: this.freeScroll,
        mouseWheel: this.mouseWheel ? {
          speed: 20,
          invert: false,
          easeTime: 300
        } : undefined,
        bounce: this.bounce,
        zoom: this.zoom,
        autoBlur: false,
        invertWheelDirection: this.invertWheelDirection
      };
      this.scroll = new BScroll(this.$refs.wrapper, options);
      this.scroll.on('touchEnd', (pos) => {
        this._focusOut();
      });
      if (this.listenScroll) {
        this.scroll.on('scroll', (pos) => {
          this.$emit('scroll', pos);
        });
      }
      if (this.listenScrollEnd) {
        this.scroll.on('scrollEnd', (pos) => {
          this.$emit('scroll-end', pos);
        });
      }
      if (this.listenBeforeScroll) {
        this.scroll.on('beforeScrollStart', () => {
          this.$emit('beforeScrollStart');
        });
        this.scroll.on('scrollStart', () => {
          this.$emit('scroll-start');
        });
      }
      if (this.pullDownRefresh) {
        this._initPullDownRefresh();
      }
      if (this.pullUpLoad) {
        this._initPullUpLoad();
      }
      if (this.listenInputKeyboard) {
        this._initListenInputKeyboard();
      }
    },
    disable () {
      this.scroll && this.scroll.disable();
    },
    enable () {
      this.scroll && this.scroll.enable();
    },
    refresh () {
      this.scroll && this.scroll.refresh();
    },
    scrollTo () {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    autoPullDownRefresh () {
      this.scroll && this.scroll.autoPullDownRefresh();
    },
    scrollToElement () {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    },
    clickItem (e, item) {
      this.$emit('click', item);
    },
    destroy () {
      this.scroll.destroy();
    },
    forceUpdate (dirty) {
      if (this.pullDownRefresh && this.isPullingDown) {
        this.isPullingDown = false;
        this._reboundPullDown().then(() => {
          this._afterPullDown();
        });
      } else if (this.pullUpLoad && this.isPullUpLoad) {
        this.isPullUpLoad = false;
        this.scroll.finishPullUp();
        this.pullUpDirty = dirty;
        this.refresh();
      } else {
        this.refresh();
      }
    },
    _initPullDownRefresh () {
      this.scroll.on('pullingDown', () => {
        this.beforePullDown = false;
        this.isPullingDown = true;
        this.$emit('pullingDown');
      });
      this.scroll.on('scroll', (pos) => {
        if (!this.pullDownRefresh) {
          return;
        }
        if (this.beforePullDown) {
          this.bubbleY = Math.max(0, pos.y + this.pullDownInitTop);
          this.pullDownStyle = `top:${Math.min(pos.y + this.pullDownInitTop, 10)}px`;
        } else {
          this.bubbleY = 0;
        }
        if (this.isRebounding) {
          this.pullDownStyle = `top:${10 - (this.pullDownRefresh.stop - pos.y)}px`;
        }
      });
    },
    _initPullUpLoad () {
      this.scroll.on('pullingUp', () => {
        this.isPullUpLoad = true;
        this.$emit('pullingUp');
      });
    },
    _reboundPullDown () {
      const { stopTime = 600 } = this.pullDownRefresh;
      return new Promise((resolve) => {
        setTimeout(() => {
          this.isRebounding = true;
          this.scroll.finishPullDown();
          resolve();
        }, stopTime);
      });
    },
    _afterPullDown () {
      setTimeout(() => {
        this.pullDownStyle = `top:${this.pullDownInitTop}px`;
        this.beforePullDown = true;
        this.isRebounding = false;
        this.refresh();
      }, this.scroll.options.bounceTime);
    },
    _initListenInputKeyboard () {
      if (/Android/gi.test(navigator.userAgent)) {
        window.addEventListener('focusin', () => {
          // 键盘弹出事件处理
          if (focusTimer) {
            window.clearTimeout(focusTimer);
          }
          let dom = this.$el.querySelector(`input:focus`);
          if (dom) {
            this.scroll.scrollToElement(dom, 200, true, this.InputKeyboardOffsetY);
          }
          setTimeout(() => {
            let dom = this.$el.querySelector(`input:focus`);
            if (dom) {
              this.scroll.scrollToElement(dom, 200, true, this.InputKeyboardOffsetY);
            }
          }, 500);
        });
        const innerHeight = window.innerHeight;
        window.addEventListener('resize', () => {
          const newInnerHeight = window.innerHeight;
          if (innerHeight > newInnerHeight) {
          } else {
            // 键盘收起事件处理
            this._focusOut();
          }
        });
      }
    },
    _focusOut () {
      if (this.listenInputKeyboard) {
        let dom = document.querySelector(`input:focus`);
        if (dom) {
          if (focusTimer) {
            window.clearTimeout(focusTimer);
          }
          focusTimer = setTimeout(() => {
            dom.blur();
            setTimeout(() => {
              this.scroll.refresh();
            }, 250);
          }, 100);
        } else {
          setTimeout(() => {
            this.scroll.refresh();
          }, 150);
        }
      }
    }
  },
  watch: {
    data () {
      setTimeout(() => {
        this.forceUpdate(true);
      }, this.refreshDelay);
    }
  },
  components: {
    Loading,
    Bubble
  }
};
</script>
<style lang="scss" scoped>
  @import "../../style/var";
  @include namespace(wrapper){
    position: relative;
    height: 100%;
    overflow: hidden;
    @include namespace(scroll__content){
      position: relative;
      z-index: 1
    }
    @include state(pulldown){
      position: absolute;
      width: 100%;
      left: 0;
      display: flex;
      justify-content:center;
      align-items: center;
      transition: all;
    }
    @include position(pulldown-after){
      margin-top: 10px
    }
    @include state(pullup){
      width: 100%;
      display: flex;
      justify-content:center;
      align-items:center;
      padding: 10px;
    }
  }
</style>
